import { Col, Row } from 'antd';
import type { FC, ReactNode } from 'react';
import { ReactComponent as ChevronLeft } from '../../../assets/icons/chevron-left.svg';
import IconButton from '../Buttons/IconButton';

interface FilterCardProps {
  title: ReactNode;
  children?: ReactNode;
  expanded?: boolean;
  setExpanded?: (value: boolean) => void;
  shadow?: boolean;
  headerBackground?: string;
  headerClassName?: string;
  showBorder?: boolean;
  className?: string;
  labelForTestId?: string;
  customHeader?: ReactNode;
  hideHeader?: boolean;
}

const FilterCard: FC<FilterCardProps> = ({
  title,
  children,
  expanded = true,
  setExpanded,
  shadow = true,
  headerBackground = 'white',
  showBorder = false,
  className = '',
  headerClassName = '',
  customHeader,
  labelForTestId,
  hideHeader = false, // New prop added
}) => {
  return (
    <div
      className={`${className} ${showBorder ? 'border-muted' : 'border-none'} ${
        shadow && 'box-shadow'
      } ${!expanded && 'flex-1'} br-5 `}
      data-testid={labelForTestId ? labelForTestId : ''}
    >
      {!hideHeader && ( // Conditionally render the header
        <div
          className={`card-title  ${setExpanded ? 'cursor-pointer' : ''} ${
            expanded ? '' : 'border-none'
          } background-${headerBackground} ${headerClassName}`}
          {...(setExpanded ? { onClick: () => setExpanded(!expanded) } : {})}
        >
          <Row justify="space-between" align="middle" className="filter-card-title-row">
            {customHeader ? (
              customHeader
            ) : (
              <>
                <Col>
                  {/* biome-ignore lint/a11y/noLabelWithoutControl: <explanation> */}
                  <label className={`card-title-text ${setExpanded ? 'cursor-pointer' : ''}`}>{title}</label>
                </Col>
                {setExpanded && (
                  <Col className={`${!expanded ? 'mt-15' : ''}`}>
                    <IconButton>
                      <ChevronLeft />
                    </IconButton>
                  </Col>
                )}
              </>
            )}
          </Row>
        </div>
      )}
      {children}
    </div>
  );
};

export default FilterCard;
